import React, { Component } from 'react'
import styled from 'styled-components'
import { upperlower } from '../utlis/functions'
import { geolocated } from 'react-geolocated'

import {
  Modal,
  Header,
  Shape,
  CustomSlider,
  XLMMText,
  XXMText,
  Button,
  StyledImage,
  PageWrapper,
  Card,
  FlexWrapper,
  XXLText,
  XXXMText,
  ProgressBar,
  Tooltip,
  ListView,
  Checkbox,
  Icon,
  Circle,
  Counter,
  DefaultText,
  XMText,
  FlexWrap,
  OverlayChild,
  PageLoader,
  CardWrap,
  TextField,
  FormikForm,
  SmallestText,
  XLMText,
  XCMText
} from '../components'
import qs from 'qs'
import { addList } from '../utlis/validators'
import { Formik, Field } from 'formik'
import Cookies from 'js-cookie'
import { API_URL } from '../constants'
import axios from 'axios'
import { roudingValue } from '../utlis/functions'
import { isEmpty, get, size, forEach, toUpper, map, xor, has, values, truncate } from 'lodash'

const StyledShape = styled(Shape)`
  left: calc(50% - 4px) !important;
`
const ContentWrap = styled.div`
  width: 100%;
`

const CustomCard = styled(Card)`
  position: Fixed !important;
  top: 60px;
  z-index: 999999;
  max-width: 768px;
`
const CustomFlex = styled(FlexWrapper)`
  div {
    max-width: 340px;
    & > button {
      padding: 0 10px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    & > button:nth-child(2) {
      width: 410px;
      font-size: 14px;
      font-weight: normal;
      line-height: 1.57;
      color: #078489;
      margin: 16px 0 0 20px;
    }
  }
  position: fixed;
  bottom: 0px;
  left: 0;
  z-index: 999999;
  .scan-receipt {
    color: #124b5f !important;
  }
`

const mapOrder = (array, order, key) => {
  array.sort(function(a, b) {
    var A = a[key],
      B = b[key]

    if (order.indexOf(A) > order.indexOf(B)) {
      return 1
    } else {
      return -1
    }
  })

  return array
}

class SingleList extends Component {
  state = {
    cardIndex: 0,
    listsData: [],
    listDetails: {},
    shopInStoreMode: false,
    showModal: false,
    deleteList: false,
    renameList: false,
    isLoading: false,
    checkboxes: [],
    scrolledToBottom: false,
    lastScrollPos: 0,
    comingSoonModel: false
  }

  async fetchListDetails() {
    try {
      const { data: listDetails } = await axios.get(`${API_URL}/ShoppingLists/${this.props.match.params.tab}`)
      this.setState({ listDetails })
    } catch (error) {
      console.error(error)
    }
  }

  async componentDidUpdate(prevProps) {
    if (prevProps.coords === null && get(this.props, 'coords', null)) {
      const {
        data: { status }
      } = await axios.get(
        `${API_URL}/UserShoppingListProducts/userShoppingProductList/${Cookies.get('user_id')}/${
          this.props.match.params.tab
        }/${this.props.coords.latitude},${this.props.coords.longitude}`
      )
      this.setState({ listsData: status })
    }
  }

  async componentDidMount() {
    window.scrollTo(0, 0)
    const shopInStoreMode = get(this.props, 'location.state.shopInStoreMode', false)
    this.setState({
      shopInStoreMode,
      cardIndex: get(this.props, 'location.state.cardIndex', 0),
      checkboxes: get(this.props, 'location.state.checkboxes', []),
      scrolledToBottom: get(this.props, 'location.state.scrolledToBottom', false)
    })
    this.fetchListDetails()
    this.setState({ isLoading: true })
    try {
      let status = {}
      if (get(this.props, 'coords.latitude', null)) {
        const data = await axios.get(
          `${API_URL}/UserShoppingListProducts/userShoppingProductList/${Cookies.get('user_id')}/${
            this.props.match.params.tab
          }/${this.props.coords.latitude},${this.props.coords.longitude}`
        )
        status = data.data.status
      } else {
        const data = await axios.get(
          `${API_URL}/UserShoppingListProducts/userShoppingProductList/${Cookies.get('user_id')}/${
            this.props.match.params.tab
          }/null`
        )
        status = data.data.status
      }

      this.setState({ listsData: status, isLoading: false })
    } catch (error) {
      console.error('ERR', error)
      this.setState({ isLoading: false })
    }
  }

  openInstaWarning = () => {}

  createInstaUrl = () => {
    const stores = Object.keys(this.state.listsData)
    const selectedStore = this.state.listsData[stores[this.state.cardIndex]]

    let ingredients = ''
    let quantity = ''

    if (size(selectedStore.products) > 0) {
      forEach(selectedStore.products, item => {
        if (item.isSubstituted === false) {
        } else {
          ingredients += `&ingredients%5B%5D=${encodeURIComponent(item.productName)}`
          quantity += `&quantities%5B%5D=${encodeURIComponent(item.productQuantity)}`
        }
      })

      window.open(
        `https://www.instacart.com/store/partner_recipe?description=Live%20Your%20Values&image_url=https://i.imgur.com/jE9nXn3.png${ingredients}${quantity}&partner_name=greenchoicenow.com&recipe_url=https://app.greenchoice.io&title=GreenChoice&guest=true`,
        '_blank'
      )
    }
  }

  /*  redirectToOuterLink(name) {
    console.log('name', name)
    if (name === 'Freshdirect') {
      window.open('https://www.freshdirect.com/')
    } else if (name === 'Peapod') {
      window.open('https://www.peapod.com/')
    } else if (name === 'Walmart') {
      window.open('https://www.walmart.com/')
    }
  } */
  handleChangeInQuantity = async (grocer, product, action) => {
    if (this.state.listsData[grocer].products[product].userQuantity === 0 && action === 'subtract') {
      return
    }

    if (grocer === 'Master List') {
      // console.log(grocer, product, action)
      const query = {
        filter: {
          where: {
            userId: Cookies.get('user_id'),
            shoppingListId: this.state.listDetails.id,
            productCode: product
          }
        }
      }

      const { data } = await axios.get(`${API_URL}/UserShoppingListProducts?${qs.stringify(query)}`)

      if (this.state.listsData[grocer].products[product].userQuantity === 1 && action === 'subtract') {
        if (window.confirm('Do you really want to remove the product from the list?')) {
          if (data.length > 0) {
            await axios.delete(`${API_URL}/UserShoppingListProducts/${data[0].id}`)
            this.componentDidMount()
            return
          }
        } else {
          return
        }
      }

      if (data.length > 0) {
        await axios.patch(`${API_URL}/UserShoppingListProducts/${data[0].id}`, {
          quantity:
            action === 'add'
              ? this.state.listsData[grocer].products[product].userQuantity + 1
              : this.state.listsData[grocer].products[product].userQuantity - 1
        })
        this.componentDidMount()
      }

      // await axios.patch(``)
    }

    this.setState({
      listsData: {
        ...this.state.listsData,
        [grocer]: {
          ...this.state.listsData[grocer],
          products: {
            ...this.state.listsData[grocer].products,
            [product]: {
              ...this.state.listsData[grocer].products[product],
              userQuantity:
                action === 'add'
                  ? this.state.listsData[grocer].products[product].userQuantity + 1
                  : this.state.listsData[grocer].products[product].userQuantity - 1
            }
          }
        }
      }
    })
  }
  handleScroll = e => {
    const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight
    if (this.state.lastScrollPos > e.currentTarget.scrollTop) {
      this.setState({ scrolledToBottom: false, lastScrollPos: e.currentTarget.scrollTop })
    } else if (bottom) {
      this.setState({ scrolledToBottom: true })
    }
  }
  onScroll = e => {
    if (e.nativeEvent.wheelDelta > 0) {
      this.setState({ scrolledToBottom: false })
    } else {
    }
  }
  render() {
    const {
      renameList,
      isLoading,
      deleteList,
      listsData,
      cardIndex,
      shopInStoreMode,
      listDetails,
      showModal,
      scrolledToBottom,
      checkboxes,
      comingSoonModel,
      warningModal
    } = this.state

    // get keys from the listData
    const stores = Object.keys(listsData)

    const selectedStore = listsData[stores[cardIndex]]
    const sortOrder = [
      'produce',
      'meat',
      'seafood',
      'deli',
      'fresh cheese',
      'packaged cheese',
      'dairy and eggs',
      'pantry',
      'beverages',
      'frozen',
      'bread and bakery',
      'prepared foods',
      'meals',
      'organic'
    ]

    // console.log('selectedStore', selectedStore)
    // console.log('statesss', this.state)
    const unSortedProduts = values(get(selectedStore, 'products', {}))

    const sortedProducts = mapOrder(unSortedProduts, sortOrder, 'productCategory')

    const aggregates = {}

    stores.forEach(store => {
      let totalQty = 0
      let totalGs = 0
      let totalPrice = 0
      let abstictTotal = 0
      forEach(listsData[store].products, product => {
        if (product.isSubstituted === false) {
          abstictTotal++
        } else {
          if (product.productPriceOriginal === null) {
            abstictTotal++
          }
          totalPrice +=
            (product.productPriceSale ? product.productPriceSale : product.productPriceOriginal) * product.userQuantity
          totalQty += product.userQuantity
          totalGs += product.totalGs * product.userQuantity
        }
      })
      const avgGs = totalQty > 0 ? Math.round(totalGs / totalQty) : 0
      aggregates[store] = {
        totalQty,
        totalPrice: roudingValue(totalPrice),
        avgGs,
        abstictTotal
      }
    })

    const selectedAggregate = aggregates[stores[cardIndex]]
    return (
      <React.Fragment>
        <Header
          title={
            shopInStoreMode
              ? stores.length > 0 && stores[cardIndex].replace('Insta_', '')
              : truncate(listDetails.name, {
                  length: 18
                }) || 'List'
          }
          icon="arrowBack"
          onClickBack={
            shopInStoreMode ? () => this.setState({ shopInStoreMode: false }) : () => this.props.history.push('/lists')
          }
          color="#fff"
          showEdit={stores[cardIndex] === 'Master List'}
          onClickEdit={() => this.setState({ showModal: true, renameList: true })}
          onClickDelete={() => this.setState({ showModal: true, deleteList: true })}
        />
        {isLoading && isEmpty(listsData) ? (
          <PageLoader />
        ) : isEmpty(listsData) ? (
          <div>Empty List</div>
        ) : (
          <React.Fragment>
            <CustomCard
              style={{
                display: shopInStoreMode ? 'none' : 'block'
              }}
              boxShadow="0 3px 6px 0 rgba(0, 0, 0, 0.16)"
              bgColor="#fff"
              boxRadius="0px"
              padding="10px 11px">
              <CustomSlider itemWidth={130} numberOfItems={get(stores, 'length')} margin="10px 5px">
                {map(stores, (item, idx) => (
                  <React.Fragment>
                    {item === 'Master List' ? (
                      <Card
                        padding="8px"
                        forSlick
                        height="80px"
                        bgColor="#fff"
                        boxShadow="0 3px 6px 0 rgba(0, 0, 0, 0.16)"
                        boxRadius="5px"
                        onClick={() => this.setState({ cardIndex: idx })}
                        activeCard={cardIndex === idx}>
                        <StyledShape
                          className="shape"
                          display="inline-flex"
                          padding="2px 6px"
                          backgroundColor="#fff"
                          boxShadow="0 0 2px 0 rgba(0, 0, 0, 0.25)"
                          position="absolute"
                          justifyContent="center">
                          <XXMText color="#078489">Master List</XXMText>
                        </StyledShape>
                        <FlexWrapper alignItems="center" justifyContent="center" height="60px">
                          <div style={{ paddingTop: 10 }}>
                            <Icon icon="editList" />
                          </div>
                          <XLMMText color="#124b5f">Edit List</XLMMText>
                        </FlexWrapper>
                      </Card>
                    ) : (
                      <Card
                        key={item}
                        padding="8px"
                        height="auto"
                        forSlick
                        bgColor="#fff"
                        activeCard={cardIndex === idx}
                        onClick={() => this.setState({ cardIndex: idx })}
                        boxShadow="0 3px 6px 0 rgba(0, 0, 0, 0.16)"
                        boxRadius="5px">
                        {/* <StyledShape
                              display="inline-flex"
                              padding="2px 6px"
                              backgroundColor="#fff"
                              boxShadow="0 0 2px 0 rgba(0, 0, 0, 0.25)"
                              position="absolute"
                              justifyContent="center">
                              <XLMMText color="#078489">Top Score</XLMMText>
                            </StyledShape> */}
                        <FlexWrapper>
                          <FlexWrapper viewMargin="8px 0 16px">
                            <StyledImage
                              src={get(
                                listsData[item],
                                'grocerInfo.imageUrl',
                                require('../static/images/no-image.png')
                              )}
                              alt={item}
                              height="18px"
                              margin="0 auto 0 0"
                            />
                          </FlexWrapper>
                        </FlexWrapper>
                        <FlexWrapper direction="row" alignItems="center" justifyContent="space-between">
                          {get(listsData[item], 'grocerInfo.grocerType', '') === 'Online' ? (
                            <Shape
                              display="inline-flex"
                              padding="1px 2px"
                              backgroundColor="#fff"
                              border="1px solid #00aada"
                              margin="0 4px 0 0"
                              borderRadius="18px"
                              justifyContent="center">
                              <XXMText color="#00aada">Online</XXMText>
                            </Shape>
                          ) : get(listsData[item], 'grocerInfo.grocerType', '') === 'Insta' ? (
                            <Shape
                              display="inline-flex"
                              padding="1px 2px"
                              backgroundColor="#fff"
                              border="1px solid #00aada"
                              margin="0 4px 0 0"
                              borderRadius="18px"
                              justifyContent="center">
                              {get(listsData[item], 'grocerInfo.distance', null) ? (
                                <React.Fragment>
                                  <Icon icon="distance" />
                                  <XXMText color="#00aada">
                                    {`${(get(listsData[item], 'grocerInfo.distance', 0) / 1609.344).toFixed(2)} mi` ||
                                      'Online'}
                                  </XXMText>
                                </React.Fragment>
                              ) : (
                                <XXMText color="#00aada">Online</XXMText>
                              )}
                            </Shape>
                          ) : get(listsData[item], 'grocerInfo.grocerType', '') === 'Mixed' ? (
                            <Shape
                              display="inline-flex"
                              padding="1px 2px"
                              backgroundColor="#fff"
                              border="1px solid #00aada"
                              margin="0 4px 0 0"
                              borderRadius="18px"
                              justifyContent="center">
                              {get(listsData[item], 'grocerInfo.distance', null) ? (
                                <React.Fragment>
                                  <Icon icon="distance" />
                                  <XXMText color="#00aada">
                                    {`${(get(listsData[item], 'grocerInfo.distance', 0) / 1609.344).toFixed(2)} mi` ||
                                      'Online'}
                                  </XXMText>
                                </React.Fragment>
                              ) : (
                                <XXMText color="#00aada">Online</XXMText>
                              )}
                            </Shape>
                          ) : (
                            <Shape
                              display="inline-flex"
                              padding="0px 2px 0 0"
                              backgroundColor="#fff"
                              border="1px solid #00aada"
                              margin="0 4px 0 0"
                              borderRadius="18px"
                              justifyContent="center">
                              {get(listsData[item], 'grocerInfo.distance', null) ? (
                                <React.Fragment>
                                  <Icon icon="distance" />
                                  <XXMText color="#00aada">
                                    {`${(get(listsData[item], 'grocerInfo.distance', 0) / 1609.344).toFixed(2)} mi` ||
                                      'Offline'}
                                  </XXMText>
                                </React.Fragment>
                              ) : (
                                <XXMText color="#00aada">Offline</XXMText>
                              )}
                            </Shape>
                          )}
                          <XXXMText fontWeight="bold" color="#124b5f">
                            {`$${get(aggregates[item], 'totalPrice', '')}`}
                            {get(aggregates[item], 'abstictTotal', '0') > 0 ? '*' : ''}
                          </XXXMText>
                        </FlexWrapper>
                      </Card>
                    )}
                  </React.Fragment>
                ))}
              </CustomSlider>
            </CustomCard>
            <PageWrapper viewPadding={shopInStoreMode ? '76px 16px 80px' : '198px 16px 80px'} height="auto">
              <FlexWrap
                justifyContent="space-between"
                height="100%"
                overflow="auto"
                onScroll={this.handleScroll}
                onWheel={this.onScroll}>
                <ContentWrap>
                  <Card boxShadow="0 3px 6px 0 rgba(0, 0, 0, 0.16)" borderRadius="5px" bgColor="#fff" padding={'0'}>
                    <FlexWrapper direction="row" backgroundColor="#f5f5f5" viewPadding="16px" alignItems="center">
                      <FlexWrapper>
                        <XXLText>
                          Total: $
                          {get(selectedAggregate, 'totalPrice', '') === 'na.na'
                            ? '00.00'
                            : get(selectedAggregate, 'totalPrice', '')}
                          {get(selectedAggregate, 'abstictTotal', '0') > 0 ? '*' : ''}
                        </XXLText>
                        <XXXMText>{get(selectedAggregate, 'totalQty', '')} items</XXXMText>
                      </FlexWrapper>
                      <ProgressBar strokeWidth={14} size="36px" percentage={get(selectedAggregate, 'avgGs', 0)} />
                    </FlexWrapper>
                    <CardWrap>
                      {map(sortedProducts, (item, index) => {
                        if (shopInStoreMode && item.isSubstituted === false) {
                          return null
                        }

                        const previousItem = sortedProducts[index - 1]
                        if (shopInStoreMode) {
                          return (
                            <Card
                              key={item.productCode}
                              boxRadius="0 0 5px 5px"
                              boxShadow="0 3px 6px 0 rgba(0, 0, 0, 0.16)"
                              borderRadius="5px"
                              bgColor={'#fff'}
                              padding={'16px'}>
                              <OverlayChild
                                filter={
                                  item.isSubstituted === false || this.state.checkboxes.indexOf(item.productCode) > -1
                                    ? 'blur(0px) grayscale(100%) opacity(50%)'
                                    : 'none'
                                }>
                                {toUpper(get(previousItem, 'productCategory', '')) !==
                                  toUpper(item.productCategory) && (
                                  <FlexWrapper>
                                    <Tooltip content={toUpper(item.productCategory)} type="default" />
                                  </FlexWrapper>
                                )}
                                <ListView
                                  component={
                                    <FlexWrapper direction="row" alignItems="center">
                                      <FlexWrapper direction="row" alignItems="center" flexBasis="30%" width="30%">
                                        {shopInStoreMode && (
                                          <Checkbox
                                            checked={this.state.checkboxes.indexOf(item.productCode) > -1}
                                            onChange={e => {
                                              this.setState({
                                                checkboxes: xor(this.state.checkboxes, [item.productCode])
                                              })
                                            }}
                                          />
                                        )}
                                        <Circle
                                          size="52px"
                                          minWidth="52px"
                                          boxShadow="0 2px 4px 0 rgba(0, 0, 0, 0.19)"
                                          margin="0 0 0 10px"
                                          onClick={event => {
                                            event.stopPropagation()
                                            this.props.history.push({
                                              pathname: `/products/${item.productCode}/green-score`,
                                              state: {
                                                shopInStoreMode,
                                                cardIndex,
                                                scrolledToBottom,
                                                checkboxes,
                                                lastPath: get(this.props, 'location.pathname', '')
                                              }
                                            })
                                          }}>
                                          <StyledImage
                                            /* onClick={() =>
                                              this.props.history.push(`/products/${item.productCode}/green-score`)
                                            } */
                                            src={item.productImage || require('../static/images/no-image.png')}
                                            height="36px"
                                            maxWidth="36px"
                                          />
                                        </Circle>
                                      </FlexWrapper>
                                      <FlexWrapper flexBasis="50%" width="50%" viewPadding="0 0 0 10px">
                                        {isEmpty(item.productQuantity) ? null : (
                                          <XXXMText>
                                            {size(get(item, 'productCost[0].productQuantity', '')) < 6
                                              ? toUpper(item.productQuantity)
                                              : ''}
                                          </XXXMText>
                                        )}
                                        <DefaultText
                                          color="#124b5f"
                                          onClick={event => {
                                            event.stopPropagation()
                                            this.props.history.push({
                                              pathname: `/products/${item.productCode}/green-score`,
                                              state: {
                                                shopInStoreMode,
                                                cardIndex,
                                                scrolledToBottom,
                                                checkboxes,
                                                lastPath: get(this.props, 'location.pathname', '')
                                              }
                                            })
                                          }}>
                                          {upperlower(item.productName, 'titlecase')}
                                        </DefaultText>
                                        <FlexWrapper
                                          direction="row-reverse"
                                          alignItems="center"
                                          justifyContent="space-between"
                                          width="140px">
                                          <React.Fragment>
                                            <XMText color="#078489">
                                              $
                                              {!item.productPriceOriginal
                                                ? 'na.na'
                                                : item.productPriceSale || item.productPriceOriginal}
                                            </XMText>
                                          </React.Fragment>

                                          <FlexWrapper>
                                            <Counter
                                              value={item.userQuantity}
                                              onAdd={event => {
                                                event.stopPropagation()
                                                this.handleChangeInQuantity(stores[cardIndex], item.productCode, 'add')
                                              }}
                                              onSubtract={event => {
                                                event.stopPropagation()
                                                this.handleChangeInQuantity(
                                                  stores[cardIndex],
                                                  item.productCode,
                                                  'subtract'
                                                )
                                              }}
                                            />
                                          </FlexWrapper>
                                        </FlexWrapper>
                                      </FlexWrapper>
                                      <FlexWrapper alignItems="flex-end" flexBasis="20%" width="20%">
                                        <ProgressBar
                                          strokeWidth={14}
                                          size="36px"
                                          percentage={Math.round(item.totalGs)}
                                        />
                                        {has(item, 'isSubstituted') && (
                                          <Shape
                                            padding="2px"
                                            backgroundColor="#fff"
                                            border="1px solid #208907"
                                            margin="10px 0 0 0"
                                            minWidth="max-content"
                                            justifyContent="center">
                                            <SmallestText color="#208907">
                                              {item.isSubstituted === false ? 'No Substitute' : 'Replacement'}
                                            </SmallestText>
                                          </Shape>
                                        )}
                                      </FlexWrapper>
                                    </FlexWrapper>
                                  }
                                />
                              </OverlayChild>
                            </Card>
                          )
                        } else {
                          return (
                            <Card
                              key={item.productCode}
                              boxRadius="0 0 5px 5px"
                              boxShadow="0 3px 6px 0 rgba(0, 0, 0, 0.16)"
                              borderRadius="5px"
                              bgColor={'#fff'}
                              padding={'4.5%'}
                              onClick={event => {
                                event.stopPropagation()
                                this.props.history.push({
                                  pathname: `/products/${item.productCode}/green-score`,
                                  state: {
                                    shopInStoreMode: shopInStoreMode,
                                    cardIndex: cardIndex,
                                    scrolledToBottom: scrolledToBottom,
                                    lastPath: get(this.props, 'location.pathname', '')
                                  }
                                })
                              }}>
                              <OverlayChild
                                filter={
                                  item.isSubstituted === false ? 'blur(0px) grayscale(100%) opacity(50%)' : 'none'
                                }>
                                {toUpper(get(previousItem, 'productCategory', '')) !==
                                  toUpper(item.productCategory) && (
                                  <FlexWrapper>
                                    <Tooltip content={toUpper(item.productCategory)} type="default" />
                                  </FlexWrapper>
                                )}
                                <ListView
                                  component={
                                    <FlexWrapper direction="row" alignItems="center">
                                      <FlexWrapper direction="row" alignItems="center" flexBasis="30%" width="30%">
                                        {shopInStoreMode && (
                                          <Checkbox
                                            onChange={e => {
                                              this.setState({
                                                checkboxes: xor(this.state.checkboxes, [item.productCode])
                                              })
                                            }}
                                          />
                                        )}
                                        <Circle
                                          size="52px"
                                          minWidth="52px"
                                          boxShadow="0 2px 4px 0 rgba(0, 0, 0, 0.19)"
                                          margin="0 0 0 10px">
                                          <StyledImage
                                            onClick={() =>
                                              this.props.history.push(`/products/${item.productCode}/green-score`)
                                            }
                                            src={item.productImage || require('../static/images/no-image.png')}
                                            height="36px"
                                            maxWidth="36px"
                                          />
                                        </Circle>
                                      </FlexWrapper>
                                      <FlexWrapper flexBasis="50%" width="50%" viewPadding="0 0 0 10px">
                                        {isEmpty(item.productQuantity) ? null : item.productQuantity.length <= 30 ? (
                                          <XXXMText>
                                            {size(get(item, 'productCost[0].productQuantity', '')) < 6
                                              ? toUpper(item.productQuantity)
                                              : ''}
                                          </XXXMText>
                                        ) : null}
                                        <DefaultText color="#124b5f">
                                          {upperlower(item.productName, 'titlecase')}
                                        </DefaultText>
                                        <FlexWrapper
                                          direction="row-reverse"
                                          alignItems="center"
                                          justifyContent="space-between"
                                          width="140px">
                                          <React.Fragment>
                                            <XMText color="#078489">
                                              $
                                              {!item.productPriceOriginal
                                                ? 'na.na'
                                                : item.productPriceSale || item.productPriceOriginal}
                                            </XMText>
                                          </React.Fragment>

                                          <FlexWrapper>
                                            <Counter
                                              value={item.userQuantity}
                                              onAdd={event => {
                                                event.stopPropagation()
                                                this.handleChangeInQuantity(stores[cardIndex], item.productCode, 'add')
                                              }}
                                              onSubtract={event => {
                                                event.stopPropagation()
                                                this.handleChangeInQuantity(
                                                  stores[cardIndex],
                                                  item.productCode,
                                                  'subtract'
                                                )
                                              }}
                                            />
                                          </FlexWrapper>
                                        </FlexWrapper>
                                      </FlexWrapper>
                                      <FlexWrapper alignItems="flex-end" flexBasis="20%" width="20%">
                                        <ProgressBar
                                          strokeWidth={14}
                                          size="36px"
                                          percentage={Math.round(item.totalGs)}
                                        />
                                        {has(item, 'isSubstituted') && (
                                          <Shape
                                            padding="2px"
                                            backgroundColor="#fff"
                                            border="1px solid #208907"
                                            margin="10px 0 0 0"
                                            minWidth="max-content"
                                            justifyContent="center">
                                            <SmallestText color="#208907">
                                              {item.isSubstituted === false ? 'No Substitute' : 'Replacement'}
                                            </SmallestText>
                                          </Shape>
                                        )}
                                      </FlexWrapper>
                                    </FlexWrapper>
                                  }
                                />
                              </OverlayChild>
                            </Card>
                          )
                        }
                      })}
                    </CardWrap>
                  </Card>
                </ContentWrap>
              </FlexWrap>
              <CustomFlex direction="row" viewPadding="16px" justifyContent="center">
                <FlexWrapper width="auto" direction="row" alignItems="center">
                  {shopInStoreMode ? (
                    <Button
                      label="SCAN RECEIPT"
                      className="scan-receipt"
                      margin="16px 0 0 0"
                      scanNow
                      onClick={() => this.props.history.push('/scan-receipt')}
                    />
                  ) : get(selectedStore, 'grocerInfo.storeName', '') === 'Master List' ? (
                    <Button
                      label="ADD PRODUCTS TO LIST"
                      social
                      icon="products"
                      color="#078489"
                      iconHeight="18"
                      iconWidth="20"
                      margin="16px 0 0 0"
                      orderNow
                      changeColor={'#078489'}
                      onClick={() => this.props.history.push('/products')}
                    />
                  ) : get(selectedStore, 'grocerInfo.grocerType', '') === 'Insta' ? (
                    <React.Fragment>
                      <Button
                        label="SHOP IN STORE"
                        margin="16px 0 0 0"
                        orderNow
                        changeColor={'#078489'}
                        onClick={() => this.setState({ shopInStoreMode: true, checkboxes: [] })}
                      />
                      <Button
                        onClick={() => this.setState({ warningModal: true })}
                        label="ORDER ON"
                        margin="16px 0 0 0"
                        orderNow
                        changeColor={'#078489'}
                        image={
                          <StyledImage
                            maxWidth="70px"
                            src={require('../static/images/instacart.png')}
                            alt={stores[cardIndex]}
                            margin="0"
                            height="26px"
                          />
                        }
                      />
                    </React.Fragment>
                  ) : get(selectedStore, 'grocerInfo.grocerType', '') === 'Mixed' ? (
                    <React.Fragment>
                      <Button
                        label="SHOP IN STORE"
                        margin="16px 0 0 0"
                        orderNow
                        changeColor={'#078489'}
                        onClick={() => this.setState({ shopInStoreMode: true, checkboxes: [] })}
                      />
                      <Button
                        onClick={() => this.setState({ comingSoonModel: true })}
                        namespace="Order On"
                        label="ORDER ON"
                        margin="16px 0 0 0"
                        orderNow
                        changeColor={'#078489'}
                        image={
                          <StyledImage
                            maxWidth="70px"
                            src={get(selectedStore, 'grocerInfo.imageUrl', '')}
                            alt={stores[cardIndex]}
                            margin="0"
                            height="26px"
                          />
                        }
                      />
                    </React.Fragment>
                  ) : get(selectedStore, 'grocerInfo.grocerType', '') === 'Offline' ? (
                    <React.Fragment>
                      <Button
                        label="SHOP IN STORE"
                        margin="16px 0 0 0"
                        orderNow
                        changeColor={'#078489'}
                        onClick={() => this.setState({ shopInStoreMode: true, checkboxes: [] })}
                      />
                      <Button
                        onClick={() => this.setState({ comingSoonModel: true })}
                        label="ORDER ON"
                        namespace="Order On"
                        margin="16px 0 0 0"
                        orderNow
                        changeColor={'#078489'}
                        image={
                          <StyledImage
                            maxWidth="70px"
                            src={get(selectedStore, 'grocerInfo.imageUrl', '')}
                            alt={stores[cardIndex]}
                            margin="0"
                            height="26px"
                          />
                        }
                      />
                    </React.Fragment>
                  ) : get(selectedStore, 'grocerInfo.grocerType', '') === 'Online' ? (
                    <Button
                      onClick={() => this.setState({ comingSoonModel: true })}
                      label="ORDER ON"
                      namespace="Order On"
                      margin="16px 0 0 0"
                      orderNow
                      changeColor={'#078489'}
                      image={
                        <StyledImage
                          maxWidth="70px"
                          src={get(selectedStore, 'grocerInfo.imageUrl', '')}
                          alt={stores[cardIndex]}
                          margin="0"
                          height="26px"
                        />
                      }
                    />
                  ) : null}
                </FlexWrapper>
              </CustomFlex>
            </PageWrapper>

            <Modal
              title={renameList ? 'Edit List Name' : deleteList ? 'Delete List' : ''}
              show={showModal}
              hide={!showModal}
              onClose={() => this.setState({ showModal: false, renameList: false, deleteList: false })}>
              <FlexWrapper alignItems="center">
                {deleteList ? (
                  <React.Fragment>
                    <XLMText>Are you sure want to delete this list?</XLMText>
                    <Button
                      onClick={async () => {
                        await axios.delete(`${API_URL}/ShoppingLists/${listDetails.id}`)
                        window.location.href = '/lists'
                      }}
                      size="small"
                      label="Delete"
                      namespace="Delete List"
                      volume="filled"
                      margin="48px 0 0 0"
                      type="submit"
                    />
                  </React.Fragment>
                ) : renameList ? (
                  <React.Fragment>
                    <Formik
                      enableReinitialize
                      initialValues={{ title: listDetails.name }}
                      validate={addList}
                      validateOnChange
                      onSubmit={async val => {
                        try {
                          const { data } = await axios.patch(`${API_URL}/ShoppingLists/${listDetails.id}`, {
                            name: val.title
                          })
                          this.fetchListDetails()
                          this.setState({ showModal: false, deleteList: false })
                          // await this.setState({ listExist: true, showModal: true })
                          console.log('DATA LIST', data)
                        } catch (error) {
                          console.error('ERROR', error)
                        }
                      }}
                      render={formikBag => (
                        <FormikForm>
                          <Field
                            name="title"
                            render={({ field }) => (
                              <TextField
                                {...field}
                                width="auto"
                                type="text"
                                label="Name"
                                error={formikBag.errors.title}
                              />
                            )}
                          />
                          <FlexWrapper alignItems="center">
                            <Button
                              size="small"
                              label="Update"
                              volume="filled"
                              namespace="Rename List"
                              margin="14px 0 0 0"
                              type="submit"
                            />
                          </FlexWrapper>
                        </FormikForm>
                      )}
                    />
                  </React.Fragment>
                ) : null}
              </FlexWrapper>
            </Modal>
            <Modal
              show={comingSoonModel}
              hide={!comingSoonModel}
              onClose={() => this.setState({ comingSoonModel: false })}>
              <FlexWrapper alignItems="center">
                <XCMText>Coming Soon!</XCMText>
              </FlexWrapper>
            </Modal>
            <Modal
              title="Attention"
              show={warningModal}
              hide={!warningModal}
              // list={openList || listExist}
              onClose={() => {
                this.setState({ warningModal: false })
                this.createInstaUrl()
              }}>
              <FlexWrapper alignItems="center">
                <XXLText>
                  Instacart may select the wrong grocer for you! You may have to select the grocer you want before you
                  "Continue to recipe".
                </XXLText>
                <br />
                <Button
                  label="Continue"
                  margin="0 10px"
                  size="small"
                  onClick={() => {
                    this.setState({ warningModal: false })
                    this.createInstaUrl()
                  }}
                />
              </FlexWrapper>
            </Modal>
          </React.Fragment>
        )}
      </React.Fragment>
    )
  }
}

export default geolocated({
  positionOptions: {
    enableHighAccuracy: false
  }
})(SingleList)



// WEBPACK FOOTER //
// ./src/pages/SingleList.js